import { Injectable } from '@angular/core';
import { AboutCourtFeesApisModel } from '../../models/about-court-fee/about-court-fees';
import { AboutCourtFeesModel } from '../../view-models/about-court-fees';
import { Mapper } from '../mapper';
import { AboutCourtFeesItemMapper } from './fees-items.mapper';
@Injectable({
    providedIn: 'root'
})

export class AboutCourtFeesMapper implements Mapper<AboutCourtFeesApisModel, AboutCourtFeesModel>  {
    constructor(
        private requestItemMapper: AboutCourtFeesItemMapper
    ) { }
    mapForm(param: AboutCourtFeesApisModel): AboutCourtFeesModel {
        return null!
    }

    mapTo(param: AboutCourtFeesModel): AboutCourtFeesApisModel {
        return {
            reQ_ID: param.reQID,
            filingAS: param.status,
            filingaS_DOCS: param.status2,
            items: param.accusers.items.map(x => this.requestItemMapper.mapTo(x))

        }
    }
} 